export const PROMOTION_SECTION_HELP: Record<
  1 | 2 | 3 | 4 | 5,
  { intro: string; points: string[] }
> = {
  1: {
    intro:
      'This helps your secretary answer questions about this promotion if the user asks, and helps the secretary draft the message',
    points: [
      'Name is how this promotion shows in this dashboard.',
      "What the secretary should know goes into a note in the person's secretary history, so whichever channel they see, the secretary can answer when they ask about it.",
      "Follow-through is what the secretary offers to set up when someone's interested. Info only means it explains and shares the link.",
      'Adoption outcome is what counts as success in the stats: a positive reply, or a click on the link.',
    ],
  },
  2: {
    intro: 'Who gets this, then filters that narrow it down.',
    points: [
      'All users sends to everyone. With Customise users, the audience is everyone in a selected source plus everyone in the ID list: sources only, IDs only, or both. If you pick nothing, nobody gets it.',
      'No recorded source covers people we have no sign-up source for.',
      'Filters narrow that audience: work account, engagement, and features. People need every ticked feature switched on.',
      "Invite promotions (their invite link, invite button, or Sending invites) skip anyone messaged about invites within the days you choose: another invite promotion, or a credit alert that offered invites. It's checked again just before each send.",
      "People who've turned off feature updates are skipped automatically.",
      'Holdout keeps a share of the final audience, after filters, back on purpose. They get nothing, so you can compare their adoption with the people who were told.',
      'Check audience shows how many people are eligible today and why the rest are skipped. The list is fixed when you press Launch.',
    ],
  },
  3: {
    intro: 'How it reaches people. Tick one or more.',
    points: [
      "Personal message: your secretary writes a one-off message from What the secretary should know, following How should the secretary write this message. If its wording doesn't pass review, your fallback message is sent instead.",
      "WhatsApp only allows a free message within 24 hours of the person's last message. Outside that window they get your WhatsApp card, if you've added one and it's approved in their language. Otherwise they get Dream's standard opener, and your message follows once they tap Go ahead.",
      "Card only: everyone gets your approved card, including people inside the 24-hour window, and no message or fallback is sent. People who can't get a card are skipped.",
      "The WhatsApp card needs WhatsApp's approval before launch, usually within minutes. It costs about 4.6p per UK message.",
      "Daily Briefing card: the last card on the person's Morning List, only when there's a free slot. Tell me more about this hands it to their secretary. Dismissing it counts as declined.",
      'Each person gets at most one promotion per channel, and two channels, in any 14 days.',
    ],
  },
  4: {
    intro: 'When it goes out.',
    points: [
      'Each person gets it once, in their own time zone, on one of the weekdays you tick.',
      "With Days after onboarding, the audience isn't fixed at Launch. Every hour, anyone who matches the filters and has reached day N gets it, as long as their day N falls between Start sending from (or launch day, if that's later) and Stop sending after. People who finished onboarding earlier are only included if their day N falls in that window. Only people who onboarded on WhatsApp have a finish date.",
      "Each user gets it in the earliest ticked window that's still open in their time zone.",
      "Days when they're already getting another Dream message are skipped.",
      'Anyone not reached by the end date is skipped.',
    ],
  },
  5: {
    intro: 'Check everything before you launch.',
    points: [
      "Test this promotion sends it straight away to the staff you pick, including a Daily Briefing link. Tests aren't counted in the stats.",
      "The audience preview shows the WhatsApp card's estimated cost.",
      'With fixed dates, Launch fixes the audience and schedules the sends. With days after onboarding, people are added as they reach day N. You can pause or close it from the Live tab afterwards.',
    ],
  },
};
